import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import isRequired from '../../../decorators/isRequired.decorator';
import { ReplaySubject } from 'rxjs';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'ui-camera-and-preview',
  templateUrl: './camera-and-preview.component.html',
  styleUrls: ['./camera-and-preview.component.less']
})
export class CameraAndPreviewComponent extends BaseComponent implements OnInit {

    @Input() width: number = 640;
    @Input() height: number = 480;

    @isRequired()
    @Input() takePhotoBtn: HTMLButtonElement;

    @isRequired()
    @Input() imageToPreviewRSubject$: ReplaySubject<string> | undefined;

    @Output() onPhotoTaken: EventEmitter<string> = new EventEmitter();

    dataImageSrc: string;

    private _isCaptured: boolean;

    set isCaptured(value: boolean) {
        this._isCaptured = value;
        if (this.takePhotoBtn) {
            this.takePhotoBtn.style.display = this._isCaptured ? 'none' : 'inherit';
        }
    }

    get isCaptured(): boolean {
        return this._isCaptured;
    }

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.subs = this.imageToPreviewRSubject$.subscribe((dataImage: string) => {
            if (!dataImage) {
                this.isCaptured = false;
                return;
            }
            this.getPhoto(dataImage);
            this.isCaptured = true;
        });
    }

    getPhoto(imageData: string): void {
        this.dataImageSrc = imageData;
        if (this.isCaptured) {
            this.isCaptured = false;
            return;
        }
        this.onPhotoTaken.emit(imageData);
        this.isCaptured = true;
    }

}
